import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, share } from 'rxjs';
import { Pagination, PaginationRequest } from '../models/pagination.model';
import { User } from '../models/user.model';
import { HorizonsTeam } from '../models/horizons-team.model';
import { Team } from '../models/team.model';
import { environment } from 'src/environments/environment';
import * as utils from '../../shared/helpers/utils';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  getHorizonsTeams$?: Observable<Pagination<HorizonsTeam>>;
  getTeams$?: Observable<Pagination<Team>>;

  constructor(
    private httpClient: HttpClient
  ) { }

  getUsers(pagination: PaginationRequest): Observable<Pagination<User>> {
    return this.httpClient.get<Pagination<User>>(environment.apiUrl + '/users', { params: utils.cleanParams(pagination) });
  }

  getUserDetail(user: User): Observable<User> {
    return this.httpClient.get<User>(environment.apiUrl + '/users/' + user.id);
  }

  createUser(user: User): Observable<User> {
    return this.httpClient.post<User>(environment.apiUrl + '/users', utils.cleanParams(user));
  }

  updateUser(user: User ,emptyParams?: string[]): Observable<User> {
    return this.httpClient.patch<User>(environment.apiUrl + '/users/' + user.id, utils.cleanParams(user,emptyParams));
  }

  deleteUser(id: number): Observable<User> {
    return this.httpClient.delete<User>(environment.apiUrl + '/users/' + id);
  }

  getHorizonsTeams(pagination: PaginationRequest, reload = false): Observable<Pagination<HorizonsTeam>> {
    if (!this.getHorizonsTeams$ || reload) {
      this.getHorizonsTeams$ = this.httpClient.get<Pagination<HorizonsTeam>>(environment.apiUrl + '/horizonsteams', { params: utils.cleanParams(pagination) }).pipe(share());
    }
    return this.getHorizonsTeams$;
  }

  createHorizonsTeam(horizonsTeam: HorizonsTeam): Observable<HorizonsTeam> {
    return this.httpClient.post<HorizonsTeam>(environment.apiUrl + '/horizonsteams', utils.cleanParams(horizonsTeam));
  }

  updateHorizonsTeam(horizonsTeam: HorizonsTeam): Observable<HorizonsTeam> {
    return this.httpClient.patch<HorizonsTeam>(environment.apiUrl + '/horizonsteams/' + horizonsTeam.id, utils.cleanParams(horizonsTeam));
  }

  deleteHorizonsTeam(id: number): Observable<any> {
    return this.httpClient.delete<HorizonsTeam>(environment.apiUrl + '/horizonsteams/' + id);
  }

  getTeams(pagination: PaginationRequest, reload = false): Observable<Pagination<Team>> {
    if (!this.getTeams$ || reload) {
      this.getTeams$ = this.httpClient.get<Pagination<Team>>(environment.apiUrl + '/teams', { params: utils.cleanParams(pagination) }).pipe(share());
    }
    return this.getTeams$;
  }

  createTeam(Team: Team): Observable<Team> {
    return this.httpClient.post<Team>(environment.apiUrl + '/teams', utils.cleanParams(Team));
  }

  updateTeam(Team: Team): Observable<Team> {
    return this.httpClient.patch<Team>(environment.apiUrl + '/teams/' + Team.id, utils.cleanParams(Team));
  }

  deleteTeam(id: number): Observable<any> {
    return this.httpClient.delete<Team>(environment.apiUrl + '/teams/' + id);
  }

}
